import {Client} from '../../../graphql/types'

const KUWAIT_IB_IDS = [10512, 10544, 10543, 10542, 10508]

const isDebug = () => {
  try {
    return localStorage.getItem('logs') === '1'
  } catch {
    return false
  }
}

export const overrideForKuwaitNetwork = (accounts: any[], client: Client) => {
  const debug = isDebug()

  if (!client?.metadata) {
    if (debug) console.log('[KuwaitNetwork] No client metadata, skipping override')
    return accounts
  }

  let metadata: any
  try {
    metadata =
      typeof client.metadata === 'string' ? JSON.parse(client.metadata) : client.metadata
  } catch (err) {
    console.warn('Failed to parse metadata:', client.metadata)
    return accounts
  }

  const remoteIbId = metadata?.ibFollowerData?.remoteIbId

  if (!KUWAIT_IB_IDS.includes(remoteIbId)) {
    if (debug) console.log('[KuwaitNetwork] IB ID %d is not in Kuwait network, skipping', remoteIbId)
    return accounts
  }

  const KUWAIT_IB_IDS_WITH_DEMO = [10512, 10508]
  const hasDemoAccess = KUWAIT_IB_IDS_WITH_DEMO.includes(remoteIbId)

  const allowedSubtypes = hasDemoAccess
    ? ['mt5Std', 'black', 'mt5StdDemo']
    : ['mt5Std', 'black']

  if (debug) {
    console.log('[KuwaitNetwork] IB ID: %d, demo access: %s, allowed subtypes: %o', remoteIbId, hasDemoAccess, allowedSubtypes)
    console.log('[KuwaitNetwork] Input accounts:', accounts.map((a) => ({subtype: a.accountSubtype, category: a.category})))
  }

  // Kuwait Network: only allow MT5 standard and black trading accounts.
  // For most IBs, hide all IB and affiliate accounts.
  // For IB 10508, keep IB accounts (so their clients can see/create IB wallet) but still hide affiliates.
  const filtered = accounts.filter((account) => {
    const isAllowedSubtype = allowedSubtypes.includes(account.accountSubtype)
    const isIbAccount = account.category === 'ib'
    const isAffiliate = account.category === 'affiliate'

    if (remoteIbId === 10508) {
      // Allow IB accounts in addition to the trading subtypes, but never affiliates
      return (isAllowedSubtype && !isAffiliate) || isIbAccount
    }

    // Default Kuwait behaviour: no IB or affiliate accounts
    return isAllowedSubtype && !isIbAccount && !isAffiliate
  })

  if (debug) {
    console.log('[KuwaitNetwork] Output accounts:', filtered.map((a) => ({subtype: a.accountSubtype, category: a.category})))
  }

  return filtered
}

